export default "__VITE_ASSET__CxE9153$__"